<div class="my-lines-wrapper">
  <div class="mobile-title" *ngIf="!isConfigurations">
    <p>Mis IP</p>
  </div>
  <div class="flex justify-between items-center w-full" *ngIf="!isConfigurations">
    <div style="max-width: 620px; width: 620px;">
      <app-searchbar [ngClass]="loadingApi==true ? 'disabled' : ''" (emitSearch)="searchData($event)" [clear]="clearSearch"></app-searchbar>
    </div>
    <app-welcome-user></app-welcome-user>
  </div>
  <div class="content-wrapper !h-fit" *ngIf="!showDetails && !showTelephoneConfiguration && !showFiberConfiguration">
    <div class="buttons-bar flex justify-between items-center w-full" *ngIf="!isConfigurations">
      <div class="flex items-center" style="gap: 8px;">
        <app-accent-button class="h-10" [ngClass]="loadingApi==true ? 'disabled' : ''" text="Fibra óptica"
          [selected]="currentView=='fiber'" (click)="changeView('fiber')"></app-accent-button>
        <app-accent-button class="h-10" [ngClass]="loadingApi==true ? 'disabled' : ''" text="Líneas telefónicas"
          [selected]="currentView=='lines'" (click)="changeView('lines')"></app-accent-button>
        <app-accent-button class="h-10" [ngClass]="loadingApi==true ? 'disabled' : ''" text="Líneas fijas"
          [selected]="currentView=='fixed'" (click)="changeView('fixed')"></app-accent-button>

      </div>
      <div class="arrows-wrapper flex items-center" *ngIf="!isFiltered">
        <i [ngClass]="loadingApi==true || actualPage==1 ? 'disabled' : 'enabled'" class="far fa-chevron-left"
          (click)="changePage(actualPage-1)"></i>
        <i [ngClass]="loadingApi==true || actualPage==totalPages ? 'disabled' : 'enabled'" class="far fa-chevron-right"
          (click)="changePage(actualPage+1)"></i>
      </div>
    </div>
    <div class="table-wrapper">

      <div class="error-message">
        <p>{{errorMessage}}</p>
      </div>
      <div class="error-message" *ngIf="!loading && !loadingGroups && !isFixed && !isLines && !isFiber">
        <p>No hay resultados</p>
      </div>

      <div *ngIf="loading" class="loading-wrapper">
        <mat-spinner></mat-spinner>
        <p>Cargando...</p>
      </div>

      <table class="w-full h-full" *ngIf="!loading && isLines">
        <tr class="h-14 !border-0">
          <th>
            <div class="relative inline-block text-left">
              <button (click)="toggleDropdown()" class="text-accent flex items-center">
                <i class="fa-light fa-filter mr-3"></i>
                <u>Grupos de líneas</u>
                <i class="fa-light fa-chevron-down float-right ml-3"></i>
              </button>

              <div *ngIf="isDropdownOpen"
                class="absolute mt-2 w-48 bg-white border border-tertiary rounded-button z-10">
                <ul class="">
                  <li *ngFor="let group of groups" class="px-4 py-2 flex items-center text-tertiary text-sm">
                    <input type="checkbox" [value]="group" [(ngModel)]="group.selected"
                      (change)="updateSelection(group)" class="mr-2 w-4 h-4 accent-accent">
                    {{ group.name }}
                  </li>
                </ul>
              </div>
            </div>
          </th>
          <th>Nº de línea</th>
          <th>Alias</th>
          <th>Extensión</th>
          <th>Acciones</th>
        </tr>

        <!-- Fila de Sin grupo -->
        <ng-container *ngFor="let group of groupsMap">

          <!-- <tr class="h-14 text-white cursor-pointer bg-secondary" (click)="toggleGroup(group)">
            <td colspan="4" class="pl-16">{{group.nombre}} </td>
            <td class="text-end"><i class="fa-solid fa-chevron-up right-auto" *ngIf="group.expanded"></i><i
                class="fa-solid fa-chevron-down ml-auto" *ngIf="!group.expanded"></i></td>
          </tr> -->

          <ng-container *ngIf="!loadingGroups">
            <tr *ngFor="let line of group.lineas" class="h-14">
              <td class="w-1/5 text-grey"><input *ngIf="showSelection" class="w-4 h-4 mx-2" type="checkbox"
                  [value]="true" [(ngModel)]="line.inGroup" (ngModelChange)="updateSelectedLines(line)"> {{ group.nombre
                }}
              </td>
              <td class="w-1/5">{{ line.telefono }}</td>
              <td class="w-1/5">{{ line.alias || 'Sin alias' }}</td>
              <td class="w-1/5">{{ line.short_number || 'Sin numero' }}</td>
              <td class="!w-fit">
                <span (click)="openConfiguration(line)">Configurar <i class="fal fa-edit"
                    style="margin-left: 10px;"></i></span>
                <span class="pl-10" (click)="openDetails(line)"><i class="fal fa-eye"
                    style="margin-left: 10px;"></i></span>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </table>


      <table class="w-full h-full" *ngIf="!loading && isFixed">
        <tr class="h-14 !border-0">
          <th>Nº de línea fija</th>
          <th>Tipo de línea</th>
        </tr>



        <ng-container>
          <tr *ngFor="let line of data" class="h-14">
            <td class="w-5/6">{{ line.numero }}</td>

            <td class="w-1/6">{{ line.tarifa_linea_auxiliar || 'Sin numero' }}</td>

          </tr>
        </ng-container>
      </table>

      <table class="w-full h-full" *ngIf="!loading && isFiber">
        <tr class="h-14 !border-0">
          <th>Nº IP</th>
          <th>Acciones</th>
        </tr>



        <ng-container>
          <tr *ngFor="let line of data" class="h-14">
            <td class="w-5/6">{{ line.ip }}</td>

            <td class="w-1/6">
              <span (click)="openConfiguration(line)">
                Configurar
                <i class="fal fa-edit" style="margin-left: 10px;"></i>
              </span>
            </td>

          </tr>
        </ng-container>
      </table>


      <div *ngIf="loadingGroups" class="loading-wrapper">
        <mat-spinner></mat-spinner>
        <p>Cargando...</p>
      </div>
    </div>
    <div *ngIf="!loading && groupsMap.length>0 && !isFiltered" class="flex justify-center items-center w-full"
      style="margin-top: auto;flex: 0;">
      <app-paginator style="margin-top: var(--space-blocks);" class="paddings-bottom" [totalPages]="totalPages"
        [actualPage]="actualPage" (newPageEvent)="changePage($event)"></app-paginator>
    </div>
    <div *ngIf="!loading && isFixed && !isFiltered" class="flex justify-center items-center w-full"
      style="margin-top: auto;flex: 0;">
      <app-paginator style="margin-top: var(--space-blocks);" class="paddings-bottom" [totalPages]="totalPages"
        [actualPage]="actualPage" (newPageEvent)="changePage($event)"></app-paginator>
    </div>

  </div>
  <app-line-details *ngIf="showDetails" [deatails]="showDetails" (changeDetails)="changeDetails($event)"
    [line]="lineInfo"></app-line-details>
  <app-configure-telephone-line *ngIf="showTelephoneConfiguration" [line]="showTelephoneConfiguration"
    (changeConfiguration)="closeConfiguration($event)" [telephone]="telephone"></app-configure-telephone-line>
  <app-configure-fiber-dialog *ngIf="showFiberConfiguration" (changeConfiguration)="closeConfiguration($event)"
    [ip]="ip"></app-configure-fiber-dialog>
</div>